import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import React from "react";
import { StyledButton } from "./styles";
import { CompanyLegalEntityDTO } from "../../../../../models/company-accounts/company-legal-entities";

interface Props {
  propertyLabel: string;
  property: keyof CompanyLegalEntityDTO;
  propertyValue: string;
  updateSelectedItemProperty: (
    property: keyof CompanyLegalEntityDTO,
    propertyKey?: keyof CompanyLegalEntityDTO[keyof CompanyLegalEntityDTO]
  ) => void;
  isSelected: boolean;
  propertyKey?: keyof CompanyLegalEntityDTO[keyof CompanyLegalEntityDTO];
}

const SingleLegalEntityProperty = ({
  propertyLabel,
  property,
  propertyValue,
  updateSelectedItemProperty,
  isSelected,
  propertyKey,
}: Props) => {
  const theme = useTheme();

  return (
    <>
      <TableRow>
        <TableCell>{propertyLabel} : </TableCell>
        {propertyValue ? (
          <TableCell align="left">
            {isSelected ? (
              <Badge
                style={{ color: theme.palette.success.main }}
                badgeContent={isSelected ? <FontAwesomeIcon icon={faCircleCheck} /> : <></>}
              >
                <StyledButton
                  onClick={() => updateSelectedItemProperty(property, propertyKey)}
                  variant="outlined"
                  color={"success"}
                >
                  <Typography>{propertyValue}</Typography>
                </StyledButton>
              </Badge>
            ) : (
              <StyledButton
                onClick={() => updateSelectedItemProperty(property, propertyKey)}
                variant="outlined"
                color={"primary"}
              >
                <Typography>{propertyValue}</Typography>
              </StyledButton>
            )}
          </TableCell>
        ) : (
          <TableCell></TableCell>
        )}
      </TableRow>
    </>
  );
};

export default SingleLegalEntityProperty;
